import store from '../../../store/store';
import { RmsBookstoreAddress } from '../../checkout/shop-checkout.interface';
import { StreetValidationRequest } from '../interfaces/address-validation.interface';
import { validateAddress } from '../store/address-validation';

export function formatAddressToValidation(address: RmsBookstoreAddress): StreetValidationRequest {
  return {
    street1: address.address1,
    street2: address.address2,
    city: address.city,
    state: address.state,
    zipCode: address.zipCode,
    country: address.country,
  };
}

/**
 * Gets the validated address information from RMS.
 *
 * @param address
 */
export async function getValidatedAddress(address?: RmsBookstoreAddress): Promise<RmsBookstoreAddress> {
  if (!address) {
    throw new Error('Empty address for validation.');
  }

  const validationRequest = formatAddressToValidation(address);
  const validationInfo = await store.dispatch(validateAddress(validationRequest)).unwrap();

  return {
    firstName: address.firstName,
    lastName: address.lastName,
    ...validationInfo,
    phoneNumber: address.phoneNumber
  }
}
